export function createNewMessage(text, sender, name, senderId) {
  return {
    type: "message",
    text,
    time: Date.now(),
    name,
    sender,
    senderId,
  };
}

export function createNewPrivateMessage(
  text,
  sender,
  name,
  senderId,
  selectedPeerId
) {
  return {
    type: "message",
    text,
    time: Date.now(),
    name,
    sender,
    senderId,
    selectedPeerId,
  };
}
